"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Grid_1 = tslib_1.__importDefault(require("../Grid"));
const DefaultGridLayout_1 = tslib_1.__importDefault(require("../DefaultGridLayout"));
const ExpandingGridLayout_1 = tslib_1.__importDefault(require("./ExpandingGridLayout"));
class ExpandingGrid extends Grid_1.default {
    static extractExpandingGridArgs(args) {
        if (!args[0].gridConfig) {
            const [gridConfig] = args;
            return {
                gridConfig,
                gridCssClass: "custom-expanding-grid",
                successMessage: "Data indlæst",
                loadingMessage: "Indlæser data",
                failedMessage: "Det mislykkedes at indlæse data",
                emptyMessage: "Der er ikke registreret noget data"
            };
        }
        return args[0];
    }
    constructor(...args) {
        super(ExpandingGrid.extractExpandingGridArgs(args));
    }
    resetLayout() {
        this.gridLayout = new ExpandingGridLayout_1.default(this.gridConfig);
        this.gridLayout.setDelegate(new DefaultGridLayout_1.default(this));
        this.setGridLayout(this.gridLayout);
    }
}
exports.default = ExpandingGrid;
//# sourceMappingURL=ExpandingGrid.js.map